import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as faStarRegular } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faStar as faStarSolid } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { useAuth } from '@context/auth/base';
import { ToastContext } from '@context/toast';
import {
  getFragment,
  GetUserFeaturedSoundsDocument,
  SetFeaturedSoundsDocument,
  SimpleCollectedReleaseFragmentDoc,
  useMutation,
  useQuery,
} from '@graphql/reactQuery';
import { DataTestId } from '@utils/test';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const AddAsFeatureMenuItem = ({ releaseId }: { releaseId: string }) => {
  const { authUser } = useAuth();
  const featuredSoundsData = useQuery(GetUserFeaturedSoundsDocument, {
    variables: !!authUser && { id: authUser.id },
    staleTime: 0,
  });
  const featuredSoundReleaseId = getFragment(
    SimpleCollectedReleaseFragmentDoc,
    featuredSoundsData?.data?.data.user?.featuredReleases?.[0],
  )?.id;
  const isFeaturedSound = releaseId === featuredSoundReleaseId;

  const { mutateAsync: setFeaturedSounds } = useMutation(SetFeaturedSoundsDocument, {});

  const { openToast } = ToastContext.useContainer();

  const handleClick = async () => {
    try {
      await setFeaturedSounds({ releaseIds: isFeaturedSound ? [] : [releaseId] });
      openToast({ text: 'Your profile feature was updated.', variant: 'success' });
    } catch (error) {
      // TODO: linear.app/sound/issue/ENG-9185/add-missing-observability-in-fe
      openToast({ text: 'Error updating profile feature', variant: 'error' });
    }
  };

  return (
    <DropdownMenuItem
      onClick={handleClick}
      data-testid={DataTestId.ADD_AS_FEATURE_MENU_ITEM_DROPDOWN}
    >
      <FontAwesomeIcon icon={isFeaturedSound ? faStarSolid : faStarRegular} size="lg" />
      <MenuItemLabel>{isFeaturedSound ? 'Remove as feature' : 'Add as feature'}</MenuItemLabel>
    </DropdownMenuItem>
  );
};
